import {Box, VStack} from '@chakra-ui/react';
import {colors} from 'components/providers';
import React, {FC} from 'react';
import {ISpecialProduct} from 'types';

import {ProviderProduct} from './ProviderProduct';

interface Props {
  product: ISpecialProduct;
  onClick: (product: ISpecialProduct) => void;
  is_selected?: boolean;
  isFromSlider?: boolean;
  isDesktop?: boolean;
}

export const SpecialProviderProduct: FC<Props> = React.memo(({onClick, product, is_selected, isFromSlider}) => {
  const handleClick = () => {
    onClick(product);
  };

  return (
    <VStack
      alignItems="stretch"
      cursor="pointer"
      bg={colors.white}
      borderRadius="16px"
      h="full"
      onClick={handleClick}
      position="relative"
      borderLeftColor={is_selected ? colors.pink : 'transparent'}
      _hover={{
        button: {
          bg: [, colors.pink],
          '.price': {
            color: [, colors.white],
          },
        },
      }}
    >
      <Box>
        <ProviderProduct
          onClick={() => null}
          isFromSlider={isFromSlider}
          product={
            {
              ...product,
              id: product.product_id,
              name: product.product_name,
              slug: product.provider_slug,
              price: product.price,
              image: product.product_thumbnail,
              product_img_for_list_thumbnail: product.product_thumbnail,
              ingredients: product.ingredients,
            } as any
          } //because of the be response
          disablePlus
        />
      </Box>
    </VStack>
  );
});
